/**
 * Returns the _id field, if exists, or the full object if no _id field exists
 * This was created to be used with database sub-documents,
 * since they can come as a single string containing the ID
 * or an object with an _id field
 * @param {Object | String} obj
 * @returns
 */
export const getId = obj => obj?._id || obj?.id || obj;

export const getElementAbsolutePosition = element => {
  return getElementAbsolutePositionRecursive(element);
};

export const getElementConstrainedPositionAndGeometry = (element, terminalElementId) => {
  return getElementConstrainedPositionAndGeometryRecursive(element, terminalElementId);
};

function getElementAbsolutePositionRecursive(element) {
  if (element.offsetParent) {
    let res = getElementAbsolutePositionRecursive(element.offsetParent);
    return {
      top: res.top + element.offsetTop - element.scrollTop,
      left: res.left + element.offsetLeft,
    };
  }
  return {
    top: element.offsetTop - element.scrollTop,
    left: element.offsetLeft,
    height: element.offsetHeight,
  };
}

function getElementConstrainedPositionAndGeometryRecursive(element, terminalElementId) {
  if (element?.parentElement && element.parentElement.id !== terminalElementId) {
    let res = getElementConstrainedPositionAndGeometryRecursive(
      element.parentElement,
      terminalElementId
    );
    return {
      top: res.top + element.offsetTop,
      left: res.left + element.offsetLeft,
      width: element.offsetWidth,
      height: element.offsetHeight,
    };
  }
  return {
    top: element?.offsetTop || 0,
    left: element?.offsetLeft || 0,
    height: element?.offsetHeight || 0,
  };
}

export const arrayEquals = (array1, array2) => {
  if (!(array1 && array2)) return false;

  // compare lengths - can save a lot of time
  if (array1.length != array2.length) return false;

  for (var i = 0, l = array1.length; i < l; i++) {
    if (array1[i] != array2[i]) {
      return false;
    }
  }
  return true;
};

export const toQueryParams = obj => {
  return Object.entries(obj)
    .map(([k, v]) => `${k}=${v}`)
    .join('&');
};

export const queryToJSON = query => {
  return query
    .substring(1)
    .split('&')
    .reduce((obj, item) => {
      let keyVal = item.split('=');
      return {
        ...obj,
        [keyVal[0]]: decodeURI(keyVal[1]).replace(/[#/]+/g, ''),
      };
    }, {});
};
// ***
export const getOutlineNodeForTransfer = node => {
  let newNode = {
    _id: node._id?.match(/^[0-9a-z]{24}$/) ? node._id : undefined,
    level: node.level,
    fragmentKey: node.nodeKey,
    fragmentOrder: node.nodeOrder,
    fragmentType: node.nodeType,
    nodeType: node.nodeType,
    fragmentContent: node.nodeContent,
    paragraphId: node.paragraphId || '1',
    textNodes: node.nodes,
    basisNodes: node.basisNodes || [],
  };
  if (node.children && node.children.length)
    newNode.sublevel = node.children.map(childNode => getOutlineNodeForTransfer(childNode));
  return newNode;
};

export const getOutlineNodeForSaveDisplay = node => {
  let newNode = {
    ...node,
  };
  return newNode;
};
// ***
export const getOutlineNodeForDisplay = (node, index) => {
  let newNode = {
    ...node,
    _id: (node.fragmentKey || node.nodeKey).split('-')[0],
    nodeContent: node.textFragmentContent || node.fragmentContent,
    nodeKey: node.fragmentKey || node.nodeKey,
    nodeOrder: node.fragmentOrder || node.nodeOrder,
    nodeType: node.fragmentType || node.nodeType,
    nodes: node.textNodes || node.nodes,
    index: index,
    hasFocus: false,
  };
  if (node.sublevel && node.sublevel.length) {
    newNode.sublevel = node.sublevel.map((childNode, index) =>
      getOutlineNodeForDisplay(childNode, index)
    );
    newNode.children = (node.children ? node.children : node.sublevel).map((childNode, index) =>
      getOutlineNodeForDisplay(childNode, index)
    );
  } else newNode.children = [];
  return newNode;
};

/**
 * Apply callback function to each node in the outline,
 * including nested nodes.
 */
export const forEachOutlineNode = (outlineNodes, callback) => {
  forEachOutlineNodeRecursive(outlineNodes, callback);
};

function forEachOutlineNodeRecursive(outlineNodes, callback) {
  outlineNodes?.forEach(node => {
    callback(node);
    if (node.children) forEachOutlineNodeRecursive(node.children, callback);
  });
}

export const dragElement = (elmnt, id) => {
  if (!elmnt) return; // Guard against null/undefined element

  var pos1 = 0,
    pos2 = 0,
    pos3 = 0,
    pos4 = 0;
  if (document.getElementById(`${id}`)) {
    document.getElementById(`${id}`).onmousedown = dragMouseDown;
  } else {
    elmnt.onmousedown = dragMouseDown;
  }

  function dragMouseDown(e) {
    if (
      e.target.classList.value !== 'uk-input' &&
      e.target.classList.value !== 'uk-width-3-4 uk-input' &&
      e.target.classList.value !== 'uk-input focus-field uk-width-1-1' &&
      e.target.classList.value !== 'uk-input uk-width-1-1' &&
      e.target.classList.value !== 'uk-input uk-width-3-5' &&
      e.target.classList.value !== 'uk-input label-focus-field' &&
      e.target.classList.value !== 'uk-input focus-field uk-width-3-5' &&
      e.target.classList.value !== 'uk-width-3-4 uk-input border-red' &&
      e.target.classList.value !== 'uk-input uk-width-1-5 uk-margin-small-top' &&
      e.target.classList.value !== 'uk-textarea uk-width-1-1 focus-field past-textarea'
    ) {
      e = e || window.event;
      e.preventDefault();
      pos3 = e.clientX;
      pos4 = e.clientY;
      document.onmouseup = closeDragElement;
      document.onmousemove = elementDrag;
    }
  }

  function elementDrag(e) {
    e = e || window.event;
    e.preventDefault();
    pos1 = pos3 - e.clientX;
    pos2 = pos4 - e.clientY;
    pos3 = e.clientX;
    pos4 = e.clientY;
    const { clientWidth, clientHeight } = document.documentElement;
    const rect = elmnt.getBoundingClientRect();
    const newLeft = Math.min(Math.max(0, rect.left - pos1), clientWidth - rect.width);
    const newTop = Math.min(Math.max(0, rect.top - pos2), clientHeight - rect.height);
    elmnt.style.top = newTop + 'px';
    elmnt.style.left = newLeft + 'px';
  }
  function closeDragElement() {
    document.onmouseup = null;
    document.onmousemove = null;
  }
};
export const dragRootElement = (elmnt, id) => {
  var pos1 = 0,
    pos2 = 0,
    pos3 = 0,
    pos4 = 0;
  if (document.getElementById(`${id}`)) {
    document.getElementById(`${id}`).onmousedown = dragMouseDown;
  } else {
    elmnt.onmousedown = dragMouseDown;
  }

  function dragMouseDown(e) {
    if (e.target.classList.value !== 'uk-input') {
      e = e || window.event;
      e.preventDefault();
      pos3 = e.clientX;
      pos4 = e.clientY;
      document.onmouseup = closeDragElement;
      document.onmousemove = elementDrag;
    }
  }

  function elementDrag(e) {
    e = e || window.event;
    e.preventDefault();
    pos1 = pos3 - e.clientX;
    pos2 = pos4 - e.clientY;
    pos3 = e.clientX;
    pos4 = e.clientY;
    const { scrollLeft, scrollTop } = document.documentElement;
    const newLeft = Math.min(
      Math.max(0, elmnt.offsetLeft - pos1 + scrollLeft),
      document.body.scrollWidth - elmnt.offsetWidth
    );
    const newTop = Math.min(
      Math.max(0, elmnt.offsetTop - pos2 + scrollTop),
      document.body.scrollHeight - elmnt.offsetHeight
    );
    elmnt.style.top = newTop + 'px';
    elmnt.style.left = newLeft + 'px';
  }
  function closeDragElement() {
    document.onmouseup = null;
    document.onmousemove = null;
  }
};

export const transformUserDataForUpdate = apiData => {
  return {
    id: apiData._id,
    active: apiData.active,
    active_documents: apiData.activeDocuments,
    affiliation_site: apiData.affiliationSite,
    allow_add_new_debate: apiData.allow_add_new_debate,
    allow_invite_critique: apiData.allow_invite_critique,
    allow_make_critique: apiData.allow_make_critique,
    allow_nlp_outline: apiData.allow_nlp_outline,
    allow_public_debates: apiData.allow_public_debates,
    automatic_outline_warning: apiData.automaticOutlineWarning,
    display_name: apiData.display_name,
    emails: apiData.emails,
    first_name: apiData.firstname,
    last_name: apiData.lastname,
    linkedin_id: apiData.linkedInId,
    my_affiliation: apiData.myAffiliation,
    my_website: apiData.myWebsite,
    phone_numbers: apiData.phoneNumbers,
    total_documents: apiData.totalDocuments,
    twitter_id: apiData.twitterId,
    // Other fields...
  };
};
